import GetFaqResponse from '../CRM/Responses/FaqResponse';

import Model from './Model';

export default class Faq extends Model {
    id: number;
    language_id: number;
    translation_id: number;
    faq_category_id: number | null;
    order: number;
    is_mobile: boolean;
    is_agent: boolean;
    question: string;
    answer: string;

    constructor(faq: GetFaqResponse) {
        super();
        this.assignDataToProps(faq, [
            'id',
            'language_id',
            'translation_id',
            'faq_category_id',
            'order',
            'is_mobile',
            'is_agent',
            'question',
            'answer',
        ]);
    }
}
